import React from "react";

import spinner from "./Resources/spinner.png";

const PetisgoLoader = () => {
  return (
    <div>
      <img src={spinner} alt={"Loading"} />
    </div>
  );
};

export default PetisgoLoader;
